module.exports = __webpack_public_path__ + "img/474.146b5f9c.png";